module.exports = __webpack_public_path__ + "static/media/icon_azure-blob.b686aad6.svg";